import { Link } from 'react-router-dom';
import type { VideoArticle } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoArticle;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <article className="group cursor-pointer">
      <Link to={`/article/${video.slug}`} className="block">
        <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
          <img
            src={video.coverImage}
            alt={video.title}
            title={`${video.title} - 黑桃视频高清免费在线观看`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full">
                <i className="ri-play-fill text-background-50 text-lg ml-0.5"></i>
              </div>
              <span className="text-background-50 text-sm font-medium">立即观看</span>
            </div>
          </div>
          <div className="absolute top-2 left-2 flex gap-1.5">
            {video.isHot && (
              <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-500 text-background-50">
                热门
              </span>
            )}
            {video.isNew && (
              <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-accent-500 text-background-50">
                最新
              </span>
            )}
          </div>
          <div className="absolute bottom-2 right-2 px-2 py-0.5 text-[10px] font-medium rounded bg-black/70 text-background-50">
            {video.duration}
          </div>
          <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 text-[10px] font-medium rounded bg-black/60 text-accent-400">
            <i className="ri-star-fill text-[10px]"></i>
            {video.rating}
          </div>
        </div>

        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>

        <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
          {video.description}
        </p>

        <div className="flex items-center gap-3 mt-2 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {video.viewCount > 10000
              ? `${(video.viewCount / 10000).toFixed(1)}万`
              : video.viewCount}
          </span>
          <span>{video.year}</span>
          <span className="px-1.5 py-0.5 rounded bg-background-100 text-foreground-500">{video.categoryName}</span>
        </div>
      </Link>
    </article>
  );
}